import { Typography, IcChevronUp, theme } from '@bgzt/ui';
import { Section } from '~/components';
import { getLatestUpdateTime } from '~/utils/get-ranked-keywords-latest-update-time';

import styles from './HomeRankedKeywordsTitle.module.css';

type Props = {
  onArrowClick?: () => void;
};
export const HomeRankedKeywordsTitle = ({ onArrowClick }: Props) => {
  return (
    <Section>
      <div className={styles.container}>
        <Typography variant="L4" color="gray-900">
          실시간 인기 검색어
        </Typography>
        <Typography variant="C4" color="gray-300" style={{ flexGrow: 1 }}>
          {getLatestUpdateTime() + ' 기준'}
        </Typography>
        <div className={styles.arrow} onClick={onArrowClick}>
          <IcChevronUp size={14} fill={theme.colors['gray-300']} />
        </div>
      </div>
    </Section>
  );
};
